module.exports = __webpack_public_path__ + "img/other2.b507cf14.png";